// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__fp4xi","input":"TextArea_input__wX2g9","error":"TextArea_error__SreST","characterCount":"TextArea_characterCount__vCaIn"};